import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-back\">\r\n<title>newfanhui2</title>\r\n<path d=\"M24.729 2.932l-13.446 12.988 13.309 13.102c0.316 0.312 0.512 0.746 0.512 1.226 0 0.491-0.205 0.934-0.535 1.247l-0.001 0.001c-0.333 0.302-0.773 0.491-1.257 0.504h-0.003c-0.5-0.001-0.953-0.202-1.283-0.527v0l-14.591-14.362c-0.311-0.315-0.504-0.748-0.504-1.226 0-0.489 0.202-0.931 0.526-1.248v0c0.023 0 0.046-0.023 0.069-0.023l14.683-14.179c0.325-0.317 0.77-0.512 1.26-0.512 0.502 0 0.956 0.205 1.283 0.535v0c0.316 0.312 0.512 0.746 0.512 1.226 0 0.491-0.205 0.934-0.535 1.247l-0.001 0.001z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/back.svg
// module id = RN8c
// module chunks = 14